import { render } from "./SettingColorPicker.vue?vue&type=template&id=1ca458ec&scoped=true"
import script from "./SettingColorPicker.vue?vue&type=script&lang=js"
export * from "./SettingColorPicker.vue?vue&type=script&lang=js"

import "./SettingColorPicker.vue?vue&type=style&index=0&id=1ca458ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca458ec"]])

export default __exports__